import { Component, Inject, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageEditorOptions } from './image-editor-modal.models';
import Cropper from 'cropperjs';
import { ImageService } from '../../services/image.service';


export interface ImageEditorModalOptions {
  image: File;
  imageUrl: string;
  options: ImageEditorOptions;
}

@Component({
  selector: 'gio-image-editor-modal',
  templateUrl: './image-editor-modal.component.html',
  styleUrls: ['./image-editor-modal.component.scss']
})
export class ImageEditorModalComponent implements AfterViewInit {

  @ViewChild('imageCropper')
  public cropperElement: ElementRef;

  @ViewChild('fileInput')
  public fileInputElement: ElementRef<HTMLInputElement>;

  @Input() image: File;
  @Input() options: ImageEditorOptions;
  @Input() imageUrl: string;


  sourceImage;
  imageDestination: string;
  cropper: Cropper;

  cropReady = false;

  constructor(
    public dialogRef: MatDialogRef<ImageEditorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageEditorModalOptions,
    private iService: ImageService
  ) { }


  public ngAfterViewInit() {
    if (!this.image && this.data && this.data.image) {
      this.image = this.data.image;
    }

    if (!this.image && this.data && this.data.imageUrl) {
      this.imageUrl = this.data.imageUrl;
    }

    if (!this.options && this.data && this.data.options) {
      this.options = this.data.options;
    }

    if (this.image) {
      this.readFile(this.data.image);
    } else if (this.imageUrl) {
      this.iService.getUrl(this.imageUrl, 'original')
        .then(url => {
          this.sourceImage = url;
          this.initCropper();
        });
    } else {
      this.fileInputElement.nativeElement.click();
    }
  }

  onFileChanged($event: Event) {
    const input = $event.target as HTMLInputElement;
    if (input.files) {
      this.readFile(input.files[0]);
    }

  }

  readFile(file: File): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (_event) => {
          this.sourceImage = reader.result;
        };

        reader.onloadend = () => {
          this.initCropper();
          resolve();
        };

      } catch (err) {
        reject(err);
      }

    });
  }

  initCropper() {
    setTimeout(() => {
      this.cropper = new Cropper(this.cropperElement.nativeElement, {
        aspectRatio: 1,
        autoCrop: true,
        autoCropArea: 0.8,
        background: false,
        center: true,
        minCropBoxHeight: 256,
        minCropBoxWidth: 256,
        movable: true,
        rotatable: true,
        scalable: true,
        zoomable: true,
        crop: (event) => {
          const canvas = this.cropper.getCroppedCanvas();
          this.imageDestination = canvas.toDataURL('image/png');
        },
        ready: (event) => {
          setTimeout(() => {
            this.cropReady = true;
          }, 600);
        },

      });

    }, 100);
  }

  zoom_out() {
    this.cropper.zoom(-0.1);
  }

  zoom_in() {
    this.cropper.zoom(0.1);
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    const canvas = this.cropper.getCroppedCanvas();
    const data = canvas.toDataURL('image/png');
    this.dialogRef.close(data);
  }

}
